// material-ui
import React, { useEffect, useState } from 'react';

// project imports
import ReusableList from 'ui-component/lhp-components/List';
import { Content, ListProps } from 'types/list';
import getValues, { getValuesAsync } from 'service/chart-service';
import getDevicesAsync, { getDeviceByIDAsync } from 'service/device-service';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    ClickAwayListener,
    Fade,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Input,
    InputLabel,
    NativeSelect,
    OutlinedInput,
    Paper,
    Popper,
    Radio,
    RadioGroup,
    Select,
    TextField,
    TypeAction,
    Typography
} from '@mui/material';
import getDTCsAll, { DtcRequestBody } from 'service/dtc-service';
import { gridSpacing } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';
import StartTime from 'views/variables/starttime';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import getVariablesAsync from 'service/variable-service';
import { addEntry, CustomerRequestBody, FileString, uploadFile } from 'service/upload-file-service';
import useAuth from 'hooks/useAuth';

const UploadFile = () => {
    localStorage.setItem('currentPage', '/upload-file');

    const [content, setContent] = React.useState<ListProps>({
        title: 'UploadFile',
        content: { data: [], headers: [] },
        allowCSVExport: false
    });

    const [devices, setDevices] = useState<any[]>([]);
    const [customers, setCustomers] = useState<any[]>([]);
    const [projects, setProjects] = useState<any[]>([]);
    const [vehicles, setVehicles] = useState<any[]>([]);

    const [selectedSN, setSelectedSN] = useState<string[]>([]);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
    const [selectedProjects, setSelectedProjects] = useState<string[]>([]);
    const [selectedVehicles, setSelectedVehicles] = useState<string[]>([]);
    const [btnTest, setBtnTest] = useState<boolean>();

    const [newCustomer, setNewCustomer] = React.useState<string>('');
    const [newProject, setNewProject] = React.useState<string>('');
    const [newVehicle, setNewVehicle] = React.useState<string>('');

    const [newFile, setNewFile] = React.useState<File>();
    const [attachedFile, setAttachedFile] = React.useState<File>();

    const { logout, user } = useAuth();
    const [userName, setUserName] = useState<any>('');

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [uploadResult, setUploadResult] = React.useState<any>();

    useEffect(() => {
        setUserName(user?.email);

        const fetchDropDowns = async () => {
            try {
                const devicesResponse = await getDevicesAsync();
                setDevices(devicesResponse);

                const customersResponse: Set<string> = new Set();
                //customersResponse.add('New Customer');

                devicesResponse.forEach((device: any) => {
                    if (device.Customer !== null) {
                        customersResponse.add(device.Customer);
                    }
                });

                setCustomers(
                    Array.from(customersResponse)
                        .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
                        .concat(['New Customer'])
                );
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchDropDowns();
    }, []);

    const handleCustomerChange = (_event: any, value: any[]) => {
        setSelectedProjects([]);
        setSelectedVehicles([]);
        setSelectedCustomers(value);
        if (value.includes('New Customer')) {
            setNewCustomer('');
        } else {
            setNewCustomer(value.toString());
            setNewProject('');
            setNewVehicle('');
        }
        const projectsResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (value.includes(device.Customer) && device['Project Number'] !== null) {
                projectsResponse.add(device['Project Number']);
            }
        });
        setProjects(
            Array.from(projectsResponse)
                .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
                .concat(['New Project'])
        );
    };
    const handleProjectChange = (_event: any, value: string[]) => {
        setSelectedVehicles([]);
        setSelectedProjects(value);
        if (value.includes('New Project')) {
            setNewProject('');
        } else {
            setNewProject(value.toString());
            setNewVehicle('');
        }
        const vehiclesResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (selectedCustomers.includes(device.Customer) && value.includes(device['Project Number']) && device['Vehicle ID'] !== null) {
                vehiclesResponse.add(device['Vehicle ID']);
            }
        });
        setVehicles(
            Array.from(vehiclesResponse)
                .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
                .concat(['New Vehicle'])
        );
    };
    const handleVehicleChange = (_event: any, value: string[]) => {
        setSelectedVehicles(value);
        if (value.includes('New Vehicle')) {
            setNewVehicle('');
        } else {
            setNewVehicle(value.toString());
        }
        let serialNumbersResponse: Set<string> = new Set();
        devices.forEach((device: any) => {
            if (
                selectedCustomers.includes(device.Customer) &&
                selectedProjects.includes(device['Project Number']) &&
                value.includes(device['Vehicle ID'])
            ) {
                serialNumbersResponse.add(device['Device ID']);
            }
        });
        setSelectedSN(Array.from(serialNumbersResponse).sort());
    };

    const handleNewCustomerChange = (e: any) => {
        setNewCustomer(e.target.value);
    };

    const handleNewProjectChange = (e: any) => {
        setNewProject(e.target.value);
    };

    const handleNewVehicleChange = (e: any) => {
        setNewVehicle(e.target.value);
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        setUploadResult('Loading');

        try {
            if (newFile != null) {
                setBtnTest(true);
                console.log(btnTest);
                const formData = new FormData();
                formData.append('file', newFile);
                formData.append('string', newCustomer);
                formData.append('string', newProject);
                formData.append('string', newVehicle);
                formData.append('string', userName);
                const response = await uploadFile(formData);
                setAnchorEl(e.currentTarget);
                setUploadResult(response.data);
                //setSelectedCustomers([]);
                //setSelectedProjects([]);
                //setSelectedVehicles([]);
                setNewFile(undefined);
            }
        } catch (error: any) {
            console.log(error);
            console.log(error.message);
            console.log(error.code);
            setUploadResult(error.message);
        }
    };

    const popUpTester = (e: any) => {
        setAnchorEl(anchorEl ? null : e.currentTarget);
        console.log(anchorEl);
        console.log(open);
        console.log(id);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const onFileChange = (e: any) => {
        setNewFile(e.target.files[0]);
        // formData = new FormData();
        //formData.append('file', e.target.files[0]);
    };

    const keepFile = (e: any) => {
        setNewFile(newFile ? undefined : e.target.files[0]);
    };

    const handleClickAway = () => {
        setUploadResult(null);
    };

    return (
        <form>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12} md={6} lg={3}>
                    <SubCard
                        title={
                            <span>
                                Customer <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                    >
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Autocomplete
                                    key={'selectedCustomers'}
                                    disableClearable
                                    options={customers}
                                    getOptionLabel={(option: any) => option}
                                    value={selectedCustomers}
                                    onChange={handleCustomerChange}
                                    defaultValue={[]}
                                    style={{ width: '15rem' }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            {selectedCustomers.includes('New Customer') ? (
                                <Grid item>
                                    <TextField
                                        id="customer-add-text"
                                        label="New Customer"
                                        variant="outlined"
                                        //inputProps={String}
                                        onChange={handleNewCustomerChange}
                                    />
                                </Grid>
                            ) : (
                                <div></div>
                            )}
                        </Grid>
                    </SubCard>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <SubCard
                        title={
                            <span>
                                Project Number <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                    >
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Autocomplete
                                    key={'selectedProjects'}
                                    disableClearable
                                    options={projects}
                                    getOptionLabel={(option) => option}
                                    value={selectedProjects}
                                    onChange={handleProjectChange}
                                    // defaultValue={}
                                    style={{ width: '15rem' }}
                                    disabled={selectedCustomers.length === 0}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            {selectedProjects.includes('New Project') ? (
                                <Grid item>
                                    <TextField
                                        id="project-add-text"
                                        label="New Project"
                                        variant="outlined"
                                        onChange={handleNewProjectChange}
                                    />
                                </Grid>
                            ) : (
                                <div></div>
                            )}
                        </Grid>
                    </SubCard>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <SubCard
                        title={
                            <span>
                                Vehicle ID <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                    >
                        <Grid container direction="column" spacing={3}>
                            <Grid item>
                                <Autocomplete
                                    key={'selectedVehicles'}
                                    disableClearable
                                    options={vehicles}
                                    getOptionLabel={(option) => option}
                                    value={selectedVehicles}
                                    onChange={handleVehicleChange}
                                    // defaultValue={}
                                    style={{ width: '15rem' }}
                                    disabled={selectedCustomers.length === 0 || selectedProjects.length === 0}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </Grid>
                            {selectedVehicles.includes('New Vehicle') ? (
                                <Grid item>
                                    <TextField
                                        id="vehicle-add-text"
                                        label="New Vehicle"
                                        variant="outlined"
                                        onChange={handleNewVehicleChange}
                                    />
                                </Grid>
                            ) : (
                                <div></div>
                            )}
                        </Grid>
                    </SubCard>
                </Grid>
            </Grid>
            <br></br>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12} md={6} lg={3}>
                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Button variant="contained" component="label">
                                Browse for File
                                <input id="fileInput" type="file" accept=".txt" hidden onChange={onFileChange} onClick={keepFile} />
                            </Button>
                            {newFile?.name}
                        </Grid>
                    </Grid>
                    <br></br>
                    <Grid container direction="column" spacing={3}>
                        <Grid item>
                            <Button
                                variant="contained"
                                component="label"
                                disabled={
                                    newCustomer.length === 0 ||
                                    newProject.length === 0 ||
                                    newVehicle.length === 0 ||
                                    typeof newFile === 'undefined'
                                }
                                onClick={handleSubmit}
                            >
                                Upload
                                {/* <input type="reset" hidden value="Reset" /> */}
                            </Button>
                            <div>
                                {uploadResult == 'Loading' ? (
                                    <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                                        <Box key={'loadingBox'} sx={{ display: 'flex' }}>
                                            <CircularProgress />
                                        </Box>
                                    </Grid>
                                ) : (
                                    <h1>{uploadResult}</h1>
                                )}
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};
export default UploadFile;
